// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1SGU4","error":"Textarea_error__E6Qep","readonly":"Textarea_readonly__Vi35W","disabled":"Textarea_disabled__3AZyY"};